import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Button = ({
  children,
  variant = "primary",
  icon,
  fullWidth = false,
  type = "button",
  onClick,
  className = "",
  selected = false,
  ...props
}) => {
  const baseStyles =
    "font-normal py-8 px-6 rounded-3xl flex items-center justify-center gap-4 transition-all duration-200 relative";

  const variants = {
    primary: "bg-black text-white hover:bg-gray-800",
    secondary: "bg-primary text-white hover:bg-primary-light",
    google: "bg-primary text-white hover:bg-primary-light",
    apple: "bg-black text-white hover:bg-gray-800",
    facebook: "bg-[#0963F7] text-white hover:bg-[#0963F7]/80",
    outline:
      "bg-transparent border-2 border-gray-200 text-gray-800 hover:bg-gray-50",
    individual: `bg-transparent border-2 p-6 text-left ${
      selected
        ? "border-accent-blue bg-accent-blue/10"
        : "border-gray-200 hover:border-accent-blue"
    }`,
    creator: `bg-transparent border-2 p-6 text-left ${
      selected
        ? "border-accent-coral bg-accent-coral/10"
        : "border-gray-200 hover:border-accent-coral"
    }`,
    business: `bg-transparent border-2 p-6 text-left ${
      selected
        ? "border-accent-teal bg-accent-teal/10"
        : "border-gray-200 hover:border-accent-teal"
    }`,
  };

  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`}
      {...props}
    >
      {icon && variant.match(/individual|creator|business/) ? (
        <div className="flex items-center gap-6 w-full">
          <span
            className={`text-xl ${
              variant === "individual"
                ? "text-accent-blue"
                : variant === "creator"
                ? "text-accent-coral"
                : variant === "business"
                ? "text-accent-teal"
                : ""
            }`}
          >
            <FontAwesomeIcon icon={icon} size="xl" />
          </span>
          {children}
        </div>
      ) : (
        <>
          {children && (
            <span className="flex items-center justify-center leading-none text-center">
              {children}
            </span>
          )}
          {icon && <FontAwesomeIcon icon={icon} size="xl" />}
        </>
      )}
    </button>
  );
};

export default Button;
